module.exports = __webpack_public_path__ + "static/media/ordini2.48e066e1.png";